import React from "react";
import FieldSection from "./FieldSection";
import { useAuth } from "contexts/AuthContext";

export default function UserAddresses() {
  const { user } = useAuth();

  const { contactDetails: contact } = user;

  // Helper to add `disabled: true` to all fields so they are read-only
  const makeReadOnlyFields = (fields) => {
    const readOnlyFields = {};
    for (const key in fields) {
      readOnlyFields[key] = {
        ...fields[key],
        disabled: true,  // <-- disables editing inside FieldSection
      };
    }
    return readOnlyFields;
  };

  return (
    <>
      {/* Contact Details (read-only) */}
      <FieldSection
        title="Contact Details"
        icon="address-card"
        description="Your contact details (read-only)."
        fields={makeReadOnlyFields({
          "Mobile Phone": { value: contact?.mobilePhone || "", type: "text" },
          "Home Phone": { value: contact?.homePhone || "", type: "text" },
          "Work Phone": { value: contact?.workPhone || "", type: "text" },
          "Personal Email": { value: contact?.personalEmail || "", type: "email" },
          "Work Email": { value: contact?.workEmail || "", type: "email" },
          Website: { value: contact?.website || "", type: "text" },
          Twitter: { value: contact?.twitter || "", type: "text" },
          Facebook: { value: contact?.facebook || "", type: "text" },
          LinkedIn: { value: contact?.linkedin || "", type: "text" },
        })}
        // No onSave handler since fields are read-only
      />

      {/* Permanent Address (read-only) */}
      <FieldSection
        title="Permanent Address"
        icon="map-marker-alt"
        description="Your permanent address (read-only)."
        fields={makeReadOnlyFields({
          Street: { value: user?.permanentAddress?.street || "", type: "text" },
          City: { value: user?.permanentAddress?.city || "", type: "text" },
          State: { value: user?.permanentAddress?.state || "", type: "text" },
          "Zip Code": { value: user?.permanentAddress?.zipCode || "", type: "text" },
          Country: { value: user?.permanentAddress?.country || "", type: "text" },
        })}
      />

      {/* Residential Address (read-only) */}
      <FieldSection
        title="Residential Address"
        icon="home"
        description="Your residential address (read-only)."
        fields={makeReadOnlyFields({
          Street: { value: user?.residentialAddress?.street || "", type: "text" },
          City: { value: user?.residentialAddress?.city || "", type: "text" },
          State: { value: user?.residentialAddress?.state || "", type: "text" },
          "Zip Code": { value: user?.residentialAddress?.zipCode || "", type: "text" },
          Country: { value: user?.residentialAddress?.country || "", type: "text" },
        })}
      />

      {/* Work Address (read-only) */}
      <FieldSection
        title="Work Address"
        icon="suitcase"
        description="Your work address (read-only)."
        fields={makeReadOnlyFields({
          Street: { value: user?.workAddress?.street || "", type: "text" },
          City: { value: user?.workAddress?.city || "", type: "text" },
          State: { value: user?.workAddress?.state || "", type: "text" },
          "Zip Code": { value: user?.workAddress?.zipCode || "", type: "text" },
          Country: { value: user?.workAddress?.country || "", type: "text" },
        })}
      />

      {/* School Address (read-only) */}
      <FieldSection
        title="School Address"
        icon="school"
        description="Your school address (read-only)."
        fields={makeReadOnlyFields({
          Street: { value: user?.schoolAddress?.street || "", type: "text" },
          City: { value: user?.schoolAddress?.city || "", type: "text" },
          State: { value: user?.schoolAddress?.state || "", type: "text" },
          "Zip Code": { value: user?.schoolAddress?.zipCode || "", type: "text" },
          Country: { value: user?.schoolAddress?.country || "", type: "text" },
        })}
      />

      {/* Billing Address (read-only) */}
      <FieldSection
        title="Billing Address"
        icon="address-book"
        description="Your billing address (read-only)."
        fields={makeReadOnlyFields({
          Street: { value: user?.billingAddress?.street || "", type: "text" },
          City: { value: user?.billingAddress?.city || "", type: "text" },
          State: { value: user?.billingAddress?.state || "", type: "text" },
          "Zip Code": { value: user?.billingAddress?.zipCode || "", type: "text" },
          Country: { value: user?.billingAddress?.country || "", type: "text" },
        })}
      />
    </>
  );
}
